import * as i0 from '@angular/core';
import { Component, Injectable, Inject, Directive, Input, NgModule } from '@angular/core';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import { BehaviorSubject, Observable } from 'rxjs';
import * as _ from 'lodash';
import * as i1 from '@angular/common/http';
import * as i4 from '@angular/forms';
import { FormsModule } from '@angular/forms';

class AuthorizationsComponent {
    constructor() { }
    ngOnInit() {
    }
    static { this.ɵfac = function AuthorizationsComponent_Factory(t) { return new (t || AuthorizationsComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AuthorizationsComponent, selectors: [["lib-authorizations"]], decls: 2, vars: 0, template: function AuthorizationsComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "p");
            i0.ɵɵtext(1, " authorizations works hehe! ");
            i0.ɵɵelementEnd();
        } }, encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthorizationsComponent, [{
        type: Component,
        args: [{ selector: 'lib-authorizations', template: `
    <p>
      authorizations works hehe!
    </p>
  ` }]
    }], () => [], null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(AuthorizationsComponent, { className: "AuthorizationsComponent", filePath: "lib/authorizations.component.ts", lineNumber: 13 }); })();

class AuthorizationMessageComponent {
    constructor() {
        this.message = "test";
        this.severiity = "H";
    }
    ngOnInit() {
        if (this.severiity === 'H') {
            this.cssName = 'high';
        }
        else if (this.severiity === 'M') {
            this.cssName = 'medium';
        }
        else {
            this.cssName = 'low';
        }
    }
    static { this.ɵfac = function AuthorizationMessageComponent_Factory(t) { return new (t || AuthorizationMessageComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AuthorizationMessageComponent, selectors: [["app-authorization-message"]], decls: 2, vars: 2, consts: [[1, "padding-10px", "auth-message", 3, "ngClass"]], template: function AuthorizationMessageComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "p", 0);
            i0.ɵɵtext(1);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.cssName);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.message);
        } }, dependencies: [i3.NgClass], styles: [".high[_ngcontent-%COMP%]{color:#ff0500;background-color:#fff9f9;font-weight:700;border:1px solid #ff0500}.medium[_ngcontent-%COMP%]{color:#9c5d00;background-color:#ff980052;font-weight:700;border:1px solid #ff9800}.low[_ngcontent-%COMP%]{color:#259229;background-color:#4caf502e;font-weight:700;border:1px solid #4CAF50}.auth-message[_ngcontent-%COMP%]{padding:15px;margin:20px;border-radius:none!important;text-align:center}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthorizationMessageComponent, [{
        type: Component,
        args: [{ selector: 'app-authorization-message', template: "<p [ngClass]=\"cssName\" class=\"padding-10px auth-message\">{{message}}</p>", styles: [".high{color:#ff0500;background-color:#fff9f9;font-weight:700;border:1px solid #ff0500}.medium{color:#9c5d00;background-color:#ff980052;font-weight:700;border:1px solid #ff9800}.low{color:#259229;background-color:#4caf502e;font-weight:700;border:1px solid #4CAF50}.auth-message{padding:15px;margin:20px;border-radius:none!important;text-align:center}\n"] }]
    }], () => [], null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(AuthorizationMessageComponent, { className: "AuthorizationMessageComponent", filePath: "lib/components/authorization-message/authorization.message.component.ts", lineNumber: 8 }); })();

class AuthorizationService {
    constructor(http, config) {
        this.http = http;
        this.config = config;
        this._uiAuthorizations = new BehaviorSubject(null);
        this._adminPlans = new BehaviorSubject(null);
        this._allowedMemberPlans = new BehaviorSubject([]);
        this._userRoles = new BehaviorSubject([]);
        this._userProfile = new BehaviorSubject(null);
        this.apiCallRetries = 0;
        this._status = new BehaviorSubject('NOT_INITIALIZED');
    }
    loadUserAuthorizations() {
        this._status.next('IN_PROGRESS');
        return Observable.create((observer) => {
            if (this.config && this.config.cacheKey && sessionStorage.getItem(this.config.cacheKey)) {
                this.userProfile = JSON.parse(sessionStorage.getItem(this.config.cacheKey));
                this._status.next('SUCCESS FROM CACHE');
                this.processUserProfile(this.userProfile);
                this._userProfile.next(this.userProfile);
                observer.next(this.userProfile);
                observer.complete();
            }
            else {
                if (this.userProfileCall) {
                    this.userProfileCall.unsubscribe();
                }
                this.userProfileCall = this.http.get(this.config.USER_PROFILE_URL).subscribe((profile) => {
                    if (profile) {
                        this._status.next('SUCCESS');
                        this.userProfile = profile;
                        this.processUserProfile(profile);
                        this._userProfile.next(profile);
                        if (this.config.cacheKey) {
                            sessionStorage.setItem(this.config.cacheKey, JSON.stringify(profile));
                        }
                        observer.next(profile);
                        observer.complete();
                    }
                    else {
                        this._status.next('NO_PROFILE');
                        observer.next(profile);
                        observer.complete();
                    }
                }, e => {
                    this._status.next('FAILED');
                    console.log(e);
                    observer.next(e);
                    observer.complete();
                });
            }
        });
    }
    processUserProfile(userProfile) {
        this.userProfile = userProfile;
        const adminPlans = [];
        if (this.userProfile.contextBasedAuthorizations && this.userProfile.contextBasedAuthorizations['ADMINPLAN']) {
            this.userProfile.contextBasedAuthorizations['ADMINPLAN'].forEach(ap => {
                adminPlans.push(ap.value);
            });
        }
        this.processAllowedMemberPlans(this.userProfile);
        this._adminPlans.next(adminPlans);
        this._userRoles.next(this.userProfile.roles);
    }
    /**
     * Get ui authorizations elemnts by page name for a logged in user.
     * @param page
     */
    getUIAuthorizationsByPage(page) {
        return Observable.create((observer) => {
            const authorizations = this.aggregatedUIAuthorizations[page];
            observer.next(authorizations);
            observer.complete();
        });
    }
    getAllUIAuthorizations() {
        return Observable.create((observer) => {
            let authorizations = {};
            if (this.userProfile) {
                authorizations = this.mergeAuthorizations(authorizations, this.userProfile.uiAuthorizations);
                authorizations = this.findMergeAllUIAuthorizations(authorizations, this.userProfile.contextBasedAuthorizations);
                observer.next(authorizations);
                observer.complete();
            }
            else if (this.apiCallRetries <= 3) {
                this.apiCallRetries++;
                this.loadUserAuthorizations().subscribe((profile) => {
                    if (profile) {
                        authorizations = this.mergeAuthorizations(authorizations, this.userProfile.uiAuthorizations);
                        authorizations = this.findMergeAllUIAuthorizations(authorizations, this.userProfile.contextBasedAuthorizations);
                    }
                    observer.next(authorizations);
                    observer.complete();
                });
            }
        });
    }
    findMergeAllUIAuthorizations(authorizations, element) {
        if (element) {
            Object.keys(element).forEach(e => {
                let rootElement = element[e];
                Object.keys(rootElement).forEach(ce => {
                    const data = rootElement[ce];
                    authorizations = this.mergeAuthorizations(authorizations, data.uiAuthorizations);
                    authorizations = this.findMergeAllUIAuthorizations(authorizations, data.childContexts);
                });
            });
        }
        return authorizations;
    }
    /**
     * Get UI authorizations by dynamic context and context values
     * if not available then returns default authorizations.
     */
    getUIAuthorizationByContextFormat(contextFormat, contextValues) {
        return Observable.create((observer) => {
            let authorizations = {};
            if (this.userProfile) {
                authorizations = this.processUIAuthorizationsByContextFormat(contextFormat, contextValues);
                observer.next(authorizations);
                observer.complete();
            }
            else if (this.apiCallRetries <= 3) {
                this.apiCallRetries++;
                this.loadUserAuthorizations().subscribe((profile) => {
                    if (profile) {
                        authorizations = this.processUIAuthorizationsByContextFormat(contextFormat, contextValues);
                    }
                    observer.next(authorizations);
                    observer.complete();
                });
            }
        });
    }
    processUIAuthorizationsByContextFormat(contextFormat, contextValues) {
        let authorizations = {};
        let currentContextNode;
        if (contextFormat && contextFormat.trim().length > 0) {
            if (contextValues && contextValues.get('PLAN') && !contextValues.get('ADMINPLAN')) {
                contextValues.set('ADMINPLAN', this.findAdminPlanByMemberPlan(contextValues.get('PLAN')));
            }
            const formats = contextFormat.split('/');
            formats.forEach((f, i) => {
                let contextValue = contextValues.get(f);
                currentContextNode = this.findContextNodeByValue(i, currentContextNode, f, contextValue);
                if (currentContextNode) {
                    authorizations = this.mergeAuthorizations(authorizations, currentContextNode.uiAuthorizations);
                }
            });
            authorizations = this.mergeAuthorizations(authorizations, this.userProfile.uiAuthorizations);
        }
        else {
            authorizations = this.mergeAuthorizations(authorizations, this.userProfile.uiAuthorizations);
        }
        return authorizations;
    }
    findContextNodeByValue(index, node, format, value) {
        if (node && node.childContexts && node.childContexts[format]) {
            const isNotExcluded = this.checkIfValueIsExcluded(node.childContextExclusions != null ? node.childContextExclusions[format] : null, value);
            let filteredNode = node.childContexts[format].filter(cc => (cc.value === value || cc.value == '*') && isNotExcluded);
            return (filteredNode && filteredNode.length > 0) ? filteredNode[0] : null;
        }
        else if (index == 0
            && this.userProfile.contextBasedAuthorizations
            && this.userProfile.contextBasedAuthorizations[format]) {
            let filteredNode = this.userProfile.contextBasedAuthorizations[format].filter(c => (c.value === value || c.value == '*'));
            return (filteredNode && filteredNode.length > 0) ? filteredNode[0] : null;
        }
        return null;
    }
    checkIfValueIsExcluded(exclusions, value) {
        let isNotExcluded = true;
        if (exclusions && exclusions.length > 0)
            isNotExcluded = exclusions.filter(v => v == value).length <= 0;
        return isNotExcluded;
    }
    /**
     * Get UI authorizations by plan context adminplan/plan/clientId/subClientId
     * if not available then returns default authorizations.
     */
    getUIAuthorizations(planContext) {
        return Observable.create((observer) => {
            let authorizations = {};
            if (planContext && planContext.plan) {
                planContext.adminPlan = this.findAdminPlanByMemberPlan(planContext.plan);
                let aPlan = null;
                if (this.userProfile.contextBasedAuthorizations && this.userProfile.contextBasedAuthorizations['ADMINPLAN']) {
                    this.userProfile.contextBasedAuthorizations['ADMINPLAN'].forEach(ap => {
                        if (planContext.adminPlan === ap.value) {
                            aPlan = ap;
                            authorizations = this.mergeAuthorizations(authorizations, ap.uiAuthorizations);
                            let plan = null;
                            if (aPlan && aPlan.childContexts && aPlan.childContexts['PLAN'] && planContext.plan) {
                                aPlan.childContexts['PLAN'].forEach(p => {
                                    if (planContext.plan === p.value) {
                                        plan = p;
                                        authorizations = this.mergeAuthorizations(authorizations, p.uiAuthorizations);
                                    }
                                });
                            }
                            let client = null;
                            if (plan && plan.childContexts && plan.childContexts['CLIENT'] && planContext.clientSpecifiedId) {
                                plan.childContexts['CLIENT'].forEach(c => {
                                    if (planContext.clientSpecifiedId === c.value) {
                                        client = c;
                                        authorizations = this.mergeAuthorizations(authorizations, c.uiAuthorizations);
                                    }
                                });
                            }
                            if (client && client.childContexts && client.childContexts['SUBCLIENT'] && planContext.subClientSpecifiedId) {
                                client.childContexts['SUBCLIENT'].forEach(sc => {
                                    if (planContext.subClientSpecifiedId === sc.value) {
                                        authorizations = this.mergeAuthorizations(authorizations, sc.uiAuthorizations);
                                    }
                                });
                            }
                            observer.next(authorizations);
                            observer.complete();
                        }
                    });
                }
            }
            else {
                if (this.userProfile) {
                    authorizations = this.mergeAuthorizations(authorizations, this.userProfile.uiAuthorizations);
                    observer.next(authorizations);
                    observer.complete();
                }
                else {
                    this.loadUserAuthorizations().subscribe((profile) => {
                        authorizations = this.mergeAuthorizations(authorizations, profile.uiAuthorizations);
                        observer.next(authorizations);
                        observer.complete();
                    });
                }
            }
        });
    }
    mergeAuthorizations(a, b) {
        if (b && b.length === 1) {
            return _.merge(a, b[0]);
        }
        else if (b && b.length > 0) {
            b.forEach(e => {
                a = _.merge(a, e);
            });
        }
        else if (a && b && typeof a === 'object' && typeof b === 'object') {
            return _.merge(a, b);
        }
        return a;
    }
    /**
     * Get authorized adminPlan for a logged in user.
     */
    getAdminPlans() {
        return this._adminPlans;
    }
    getRoles() {
        return this._userRoles;
    }
    /**
     * Get authorized member plans by admin plan for a logged in user.
     * @param adminPlan
     */
    getMemberPlansByAdminPlan(adminPlan) {
        return Observable.create((observer) => {
            const plans = [];
            if (this.userProfile && this.userProfile.contextBasedAuthorizations) {
                const aPlan = [];
                if (this.userProfile.contextBasedAuthorizations && this.userProfile.contextBasedAuthorizations['ADMINPLAN']) {
                    this.userProfile.contextBasedAuthorizations['ADMINPLAN'].forEach(ap => {
                        if (adminPlan === ap.value) {
                            aPlan.push(ap);
                        }
                    });
                }
                if (aPlan && aPlan.length > 0) {
                    if (aPlan[0] && aPlan[0].childContexts && aPlan[0].childContexts['PLAN']) {
                        aPlan[0].childContexts['PLAN'].forEach(p => {
                            plans.push(p.value);
                        });
                    }
                }
            }
            observer.next(plans);
            observer.complete();
        });
    }
    /**
   * process authorized member plans for a logged in user.
   */
    processAllowedMemberPlans(userProfile) {
        const plans = new Set();
        if (userProfile && this.userProfile.contextBasedAuthorizations && userProfile.contextBasedAuthorizations['ADMINPLAN']) {
            const aPlan = [];
            userProfile.contextBasedAuthorizations['ADMINPLAN'].forEach(ap => {
                if (ap && ap.childContexts && ap.childContexts['PLAN']) {
                    ap.childContexts['PLAN'].forEach(p => {
                        if (p.value.indexOf('*') == -1 && p.value.indexOf('^') == -1)
                            plans.add(p.value);
                    });
                }
            });
        }
        const sortedPlans = Array.from(plans);
        this._allowedMemberPlans.next(sortedPlans.sort());
    }
    /**
     * Get authorized adminPlan by Member plan for a logged in user.
     * @param memberPlan
     */
    getAdminPlanByMemberPlan(memberPlan) {
        return Observable.create((observer) => {
            const adminPlan = this.findAdminPlanByMemberPlan(memberPlan);
            observer.next(adminPlan);
            observer.complete();
        });
    }
    findAdminPlanByMemberPlan(memberPlan) {
        let adminPlan = null;
        if (this.userProfile && this.userProfile.contextBasedAuthorizations && this.userProfile.contextBasedAuthorizations['ADMINPLAN']) {
            const aPlan = [];
            this.userProfile.contextBasedAuthorizations['ADMINPLAN'].forEach(ap => {
                const plans = [];
                if (ap && ap.childContexts && ap.childContexts['PLAN']) {
                    ap.childContexts['PLAN'].forEach(e => {
                        if (e.value === memberPlan) {
                            aPlan.push(ap);
                        }
                    });
                }
            });
            if (aPlan && aPlan.length > 0) {
                adminPlan = aPlan[0].value;
            }
        }
        return adminPlan;
    }
    static { this.ɵfac = function AuthorizationService_Factory(t) { return new (t || AuthorizationService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject('authConfig')); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AuthorizationService, factory: AuthorizationService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthorizationService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], () => [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['authConfig']
            }] }], null); })();

class UIAuthorizationService {
    constructor(authorizationService) {
        this.authorizationService = authorizationService;
        this._uiAuthorizations = new BehaviorSubject(null);
        this.authorizationService.getUIAuthorizations().subscribe(uia => {
            this._uiAuthorizations.next(uia);
        });
    }
    getUIAuthorizations(tag) {
        return this._uiAuthorizations;
    }
    setContext(context, values) {
        this.authorizationService.getUIAuthorizationByContextFormat(context, values).subscribe(uia => {
            this._uiAuthorizations.next(uia);
        });
    }
    setPlanConext(plan, clientSpecifiedId, subClientSpecifiedId) {
        this.planContext = Object.assign({
            "adminPlan": '',
            "plan": plan,
            "clientSpecifiedId": clientSpecifiedId,
            "subClientSpecifiedId": subClientSpecifiedId
        });
        this.authorizationService.getUIAuthorizations(this.planContext).subscribe(uia => {
            this._uiAuthorizations.next(uia);
        });
    }
    static { this.ɵfac = function UIAuthorizationService_Factory(t) { return new (t || UIAuthorizationService)(i0.ɵɵinject(AuthorizationService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: UIAuthorizationService, factory: UIAuthorizationService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UIAuthorizationService, [{
        type: Injectable
    }], () => [{ type: AuthorizationService }], null); })();

class AuthTagDirective {
    set authTag(authTag) {
        this.tag = authTag;
    }
    set authTagDebug(debug) {
        this.debug = debug;
    }
    set authTagDisable(disable) {
        this.disable = disable;
    }
    set authTagError(error) {
        this.error = error;
    }
    constructor(templateRef, viewContainer, authorizationService, componentFactoryResolver) {
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
        this.authorizationService = authorizationService;
        this.componentFactoryResolver = componentFactoryResolver;
        this.debug = false;
        this.disable = false;
        this.isFirstChange = true;
        this.currentViewIndex = 0;
    }
    ngOnInit() {
        this.processAuthTag();
    }
    ngOnChanges(changes) {
        if (this.isFirstChange) {
            this.isFirstChange = false;
        }
        else {
            this.processAuthTag();
        }
    }
    processAuthTag() {
        if (this.disable) {
            this.currentViewRef = this.viewContainer.createEmbeddedView(this.templateRef);
        }
        else {
            if (this.subscription) {
                this.subscription.unsubscribe();
            }
            this.subscription = this.authorizationService.getUIAuthorizations(this.tag).subscribe(authorizations => {
                if (authorizations) {
                    this.log('::: Start Log for :::' + this.tag);
                    this.log(this.templateRef);
                    this.log(this.tag);
                    let isAuthorized = null;
                    if (this.tag instanceof Array) {
                        for (const t of this.tag) {
                            if (!this.getProperty(t, authorizations)) {
                                isAuthorized = null;
                                break;
                            }
                            else {
                                isAuthorized = {};
                            }
                        }
                    }
                    else {
                        isAuthorized = this.getProperty(this.tag, authorizations);
                    }
                    this.log(isAuthorized);
                    if (isAuthorized) {
                        if (!this.currentViewRef) {
                            this.currentViewRef = this.viewContainer.createEmbeddedView(this.templateRef);
                        }
                        else {
                            this.viewContainer.insert(this.currentViewRef, this.currentViewIndex);
                        }
                        if (this.messageComponent) {
                            this.messageComponent.destroy();
                            this.messageComponent = null;
                        }
                        this.log('::Is Authorized::' + this.tag);
                    }
                    else {
                        if (this.currentViewRef) {
                            const currentViewIndex = this.viewContainer.indexOf(this.currentViewRef);
                            if (currentViewIndex >= 0) {
                                this.currentViewIndex = currentViewIndex;
                                this.viewContainer.detach(this.currentViewIndex);
                            }
                        }
                        if (this.error && this.error.length > 0) {
                            this.log('::Found Error message for ::' + this.tag);
                            this.renderAuthorizationMessage(this.error, 'H');
                            this.log('::Error message rendered for ::' + this.tag);
                        }
                        this.log('::Is Not Authorized::' + this.tag);
                    }
                    this.log('::: End Log :::');
                }
            });
        }
    }
    renderAuthorizationMessage(message, severity) {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(AuthorizationMessageComponent);
        if (!this.messageComponent)
            this.messageComponent = this.viewContainer.createComponent(componentFactory);
        this.messageComponent.instance.message = this.error;
        this.messageComponent.instance.severiity = severity;
    }
    log(l) {
        if (this.debug) {
            console.log(l);
        }
    }
    getProperty(tag, obj) {
        if (typeof obj !== 'object') {
            this.log('getProperty: obj is not an object');
        }
        if (typeof tag !== 'string') {
            this.log('getProperty: tag is not a string');
        }
        // Replace [] notation with dot notation
        tag = tag.replace(/\[["'`](.*)["'`]\]/g, '.$1');
        const val = tag.split('.').reduce(function (prev, curr) {
            return prev ? prev[curr] : undefined;
        }, obj);
        return val;
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    static { this.ɵfac = function AuthTagDirective_Factory(t) { return new (t || AuthTagDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(UIAuthorizationService), i0.ɵɵdirectiveInject(i0.ComponentFactoryResolver)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: AuthTagDirective, selectors: [["", "authTag", ""]], inputs: { authTag: "authTag", authTagDebug: "authTagDebug", authTagDisable: "authTagDisable", authTagError: "authTagError" }, features: [i0.ɵɵNgOnChangesFeature] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthTagDirective, [{
        type: Directive,
        args: [{
                selector: '[authTag]'
            }]
    }], () => [{ type: i0.TemplateRef }, { type: i0.ViewContainerRef }, { type: UIAuthorizationService }, { type: i0.ComponentFactoryResolver }], { authTag: [{
            type: Input
        }], authTagDebug: [{
            type: Input
        }], authTagDisable: [{
            type: Input
        }], authTagError: [{
            type: Input
        }] }); })();

function AuthorizationViewerComponent_ng_container_3_li_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li")(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const role_r2 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(role_r2);
} }
function AuthorizationViewerComponent_ng_container_3_li_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li")(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const plan_r3 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(plan_r3);
} }
function AuthorizationViewerComponent_ng_container_3_li_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li")(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const plan_r4 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(plan_r4);
} }
function AuthorizationViewerComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 2)(2, "div", 3);
    i0.ɵɵtext(3, "Username");
    i0.ɵɵelementStart(4, "div")(5, "ul", 4)(6, "li")(7, "span");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()()()()();
    i0.ɵɵelementStart(9, "div", 3);
    i0.ɵɵtext(10, "Roles");
    i0.ɵɵelementStart(11, "ul", 4);
    i0.ɵɵtemplate(12, AuthorizationViewerComponent_ng_container_3_li_12_Template, 3, 1, "li", 5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(13, "div", 3);
    i0.ɵɵtext(14, "Admin Plans");
    i0.ɵɵelementStart(15, "ul", 4);
    i0.ɵɵtemplate(16, AuthorizationViewerComponent_ng_container_3_li_16_Template, 3, 1, "li", 5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(17, "div", 3);
    i0.ɵɵtext(18, "Member Plans");
    i0.ɵɵelementStart(19, "ul", 4);
    i0.ɵɵtemplate(20, AuthorizationViewerComponent_ng_container_3_li_20_Template, 3, 1, "li", 5);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(21, "h3", 6);
    i0.ɵɵtext(22, "Context Based Authorizations");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "div", 2)(24, "div", 7);
    i0.ɵɵtext(25, "You can validate to check and see what sections you are authorized based on the context. Enter Context Format and matching values to check applicable Authorizations for you.");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(26, "div", 2)(27, "div", 7);
    i0.ɵɵtext(28, "Context Format: Ex: ADMINPLAN/PLAN/CLIENT_TYPE/CLIENT/CLIENT_ATTRIBUTE/SUBCLIENT/SUBCLIENT_ATTRIBUTE");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "div", 7)(30, "input", 8);
    i0.ɵɵtwoWayListener("ngModelChange", function AuthorizationViewerComponent_ng_container_3_Template_input_ngModelChange_30_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r4 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r4.format, $event) || (ctx_r4.format = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(31, "div", 2)(32, "div", 7);
    i0.ɵɵtext(33, "Context Value: Ex: DDPMI/DDPOH/GROUP/1000/MEDICARE/0010/");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "div", 7)(35, "input", 8);
    i0.ɵɵtwoWayListener("ngModelChange", function AuthorizationViewerComponent_ng_container_3_Template_input_ngModelChange_35_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r4 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r4.value, $event) || (ctx_r4.value = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(36, "div", 2)(37, "div", 9)(38, "button", 10);
    i0.ɵɵlistener("click", function AuthorizationViewerComponent_ng_container_3_Template_button_click_38_listener() { i0.ɵɵrestoreView(_r1); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.onSearch()); });
    i0.ɵɵtext(39, "Search");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(40, "div", 11);
    i0.ɵɵtext(41, "Based on the above specified context you are authorized to see below UI pages and sections. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(42, "div", 12);
    i0.ɵɵtext(43);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate(ctx_r4.profile == null ? null : ctx_r4.profile.userId);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r4.profile == null ? null : ctx_r4.profile.roles);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r4.authorizedAdminPlans);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r4.authorizedMemberPlans);
    i0.ɵɵadvance(10);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r4.format);
    i0.ɵɵadvance(5);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r4.value);
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.authorizations, " ");
} }
function AuthorizationViewerComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 13);
    i0.ɵɵtext(2, "Profile not found or unable to load profile.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} }
class AuthorizationViewerComponent {
    constructor(uiAuthorizationService, authorizationService) {
        this.uiAuthorizationService = uiAuthorizationService;
        this.authorizationService = authorizationService;
        this.format = 'ADMINPLAN/PLAN/CLIENT_TYPE/CLIENT/CLIENT_ATTRIBUTE/SUBCLIENT/SUBCLIENT_ATTRIBUTE';
        this.value = '';
    }
    ngOnInit() {
        this.uiAuthorizationService.getUIAuthorizations().subscribe(x => {
            if (x) {
                this.authorizations = JSON.stringify(x, null, '\t');
            }
            console.log(this.authorizations);
        });
        this.authorizationService._userProfile.subscribe(x => {
            if (x) {
                this.profile = x;
            }
            console.log(this.profile);
        });
        this.authorizationService._allowedMemberPlans.subscribe(x => {
            if (x) {
                this.authorizedMemberPlans = x;
            }
            console.log(this.authorizedMemberPlans);
        });
        this.authorizationService._adminPlans.subscribe(x => {
            if (x) {
                this.authorizedAdminPlans = x;
            }
            console.log(this.authorizedAdminPlans);
        });
    }
    onSearch() {
        console.log(this.format);
        console.log(this.value);
        if (this.format && this.value) {
            let values = new Map();
            const formats = this.format.split('/');
            this.value.split('/').forEach((v, i) => {
                if (i < formats.length) {
                    values.set(formats[i], v);
                }
            });
            this.uiAuthorizationService.setContext(this.format, values);
        }
        else {
            this.uiAuthorizationService.setContext(undefined, undefined);
        }
    }
    static { this.ɵfac = function AuthorizationViewerComponent_Factory(t) { return new (t || AuthorizationViewerComponent)(i0.ɵɵdirectiveInject(UIAuthorizationService), i0.ɵɵdirectiveInject(AuthorizationService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AuthorizationViewerComponent, selectors: [["lib-authorization-viewer"]], features: [i0.ɵɵProvidersFeature([UIAuthorizationService])], decls: 5, vars: 2, consts: [[1, "div-viewer"], [4, "ngIf"], [1, "row", "padding-10"], [1, "col-xs-3", "bold", "authorizations-viewer-section-title"], [1, "association-types-list"], [4, "ngFor", "ngForOf"], [1, "bold", 2, "text-transform", "uppercase"], [1, "col-xs-6"], ["type", "text", "autocomplete", "on", 3, "ngModelChange", "ngModel"], [1, "col-xs-offset-6", "col-xs-6"], ["type", "button", 1, "btn-search", 3, "click"], [1, "padding-10"], [1, "div-authorizations"], [1, "error-message"]], template: function AuthorizationViewerComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "h2");
            i0.ɵɵtext(2, "Authorization Viewer");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, AuthorizationViewerComponent_ng_container_3_Template, 44, 7, "ng-container", 1)(4, AuthorizationViewerComponent_ng_container_4_Template, 3, 0, "ng-container", 1);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.profile);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.profile == null);
        } }, dependencies: [i3.NgForOf, i3.NgIf, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgModel], styles: [".padding-10[_ngcontent-%COMP%]{padding:10px}.div-authorizations[_ngcontent-%COMP%]{border:1px solid;padding:10px;min-height:299px;margin:15px}.btn-search[_ngcontent-%COMP%]{float:right;background:green;color:#fff;border-radius:5px;width:50%}.div-viewer[_ngcontent-%COMP%]{padding:25px}.association-types-list[_ngcontent-%COMP%]{padding:2em;list-style:square;list-style-position:inside;font-size:15px}.authorizations-viewer-section-title[_ngcontent-%COMP%]{font-size:14px;text-transform:uppercase}.error-message[_ngcontent-%COMP%]{padding:15px;margin-bottom:20px;margin-top:20px;border:1px solid #ff0500;border-radius:none!important;text-transform:capitalize;text-align:center}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthorizationViewerComponent, [{
        type: Component,
        args: [{ selector: 'lib-authorization-viewer', providers: [UIAuthorizationService], template: "<div class=\"div-viewer\">\n    <h2>Authorization Viewer</h2>\n    <ng-container *ngIf=\"profile\">\n        <div class=\"row padding-10\">\n            <div class=\"col-xs-3 bold authorizations-viewer-section-title\">Username<div>\n                    <ul class=\"association-types-list\">\n                        <li>\n                            <span>{{profile?.userId}}</span>\n                        </li>\n                    </ul>\n                </div>\n            </div>\n            <div class=\"col-xs-3 bold authorizations-viewer-section-title\">Roles<ul class=\"association-types-list\">\n                    <li *ngFor=\"let role of profile?.roles\">\n                        <span>{{role}}</span>\n                    </li>\n                </ul>\n            </div>\n            <div class=\"col-xs-3 bold authorizations-viewer-section-title\">Admin Plans<ul\n                    class=\"association-types-list\">\n                    <li *ngFor=\"let plan of authorizedAdminPlans\">\n                        <span>{{plan}}</span>\n                    </li>\n                </ul>\n            </div>\n            <div class=\"col-xs-3 bold authorizations-viewer-section-title\">Member Plans<ul\n                    class=\"association-types-list\">\n                    <li *ngFor=\"let plan of authorizedMemberPlans\">\n                        <span>{{plan}}</span>\n                    </li>\n                </ul>\n            </div>\n        </div>\n        <h3 class=\"bold\" style=\"text-transform: uppercase;\">Context Based Authorizations</h3>\n        <div class=\"row padding-10\">\n            <div class=\"col-xs-6\">You can validate to check and see what sections you are authorized based on the\n                context.\n                Enter Context Format and matching values to check applicable Authorizations for you.</div>\n        </div>\n        <div class=\"row padding-10\">\n            <div class=\"col-xs-6\">Context Format: Ex:\n                ADMINPLAN/PLAN/CLIENT_TYPE/CLIENT/CLIENT_ATTRIBUTE/SUBCLIENT/SUBCLIENT_ATTRIBUTE</div>\n            <div class=\"col-xs-6\"><input type=\"text\" [(ngModel)]=\"format\" autocomplete=\"on\" /></div>\n        </div>\n\n        <div class=\"row padding-10\">\n            <div class=\"col-xs-6\">Context Value: Ex: DDPMI/DDPOH/GROUP/1000/MEDICARE/0010/</div>\n            <div class=\"col-xs-6\"><input type=\"text\" [(ngModel)]=\"value\" autocomplete=\"on\" /></div>\n        </div>\n        <div class=\"row padding-10\">\n            <div class=\"col-xs-offset-6 col-xs-6\"><button type=\"button\" class=\"btn-search\"\n                    (click)=\"onSearch()\">Search</button></div>\n        </div>\n        <div class=\"padding-10\">Based on the above specified context you are authorized to see below UI pages and\n            sections.\n        </div>\n        <div class=\"div-authorizations\">\n            {{authorizations}}\n        </div>\n    </ng-container>\n    <ng-container *ngIf=\"profile==null\">\n        <div class=\"error-message\">Profile not found or unable to load profile.</div>\n    </ng-container>\n\n</div>", styles: [".padding-10{padding:10px}.div-authorizations{border:1px solid;padding:10px;min-height:299px;margin:15px}.btn-search{float:right;background:green;color:#fff;border-radius:5px;width:50%}.div-viewer{padding:25px}.association-types-list{padding:2em;list-style:square;list-style-position:inside;font-size:15px}.authorizations-viewer-section-title{font-size:14px;text-transform:uppercase}.error-message{padding:15px;margin-bottom:20px;margin-top:20px;border:1px solid #ff0500;border-radius:none!important;text-transform:capitalize;text-align:center}\n"] }]
    }], () => [{ type: UIAuthorizationService }, { type: AuthorizationService }], null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(AuthorizationViewerComponent, { className: "AuthorizationViewerComponent", filePath: "lib/components/authorization-viewer/authorization-viewer.component.ts", lineNumber: 12 }); })();

class DefaultAuthTagDirective {
    set defaultAuthTag(defaultAuthTag) {
        this.tag = defaultAuthTag;
    }
    set defaultAuthTagDebug(debug) {
        this.debug = debug;
    }
    set defaultAuthTagDisable(disable) {
        this.disable = disable;
    }
    set defaultAuthTagError(error) {
        this.error = error;
    }
    constructor(templateRef, viewContainer, authorizationService, componentFactoryResolver) {
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
        this.authorizationService = authorizationService;
        this.componentFactoryResolver = componentFactoryResolver;
        this.debug = false;
        this.disable = false;
        this.isFirstChange = true;
        this.currentViewIndex = 0;
    }
    ngOnInit() {
        this.processDefaultAuthTag();
    }
    ngOnChanges(changes) {
        if (this.isFirstChange) {
            this.isFirstChange = false;
        }
        else {
            this.processDefaultAuthTag();
        }
    }
    processDefaultAuthTag() {
        if (this.disable) {
            this.currentViewRef = this.viewContainer.createEmbeddedView(this.templateRef);
        }
        else {
            if (this.subscription) {
                this.subscription.unsubscribe();
            }
            this.subscription = this.authorizationService.getAllUIAuthorizations().subscribe(authorizations => {
                if (authorizations) {
                    this.log('::: Start Log for :::' + this.tag);
                    this.log(this.templateRef);
                    this.log(this.tag);
                    let isAuthorized = null;
                    if (this.tag instanceof Array) {
                        for (const t of this.tag) {
                            if (!this.getProperty(t, authorizations)) {
                                isAuthorized = null;
                                break;
                            }
                            else {
                                isAuthorized = {};
                            }
                        }
                    }
                    else {
                        isAuthorized = this.getProperty(this.tag, authorizations);
                    }
                    this.log(isAuthorized);
                    if (isAuthorized) {
                        if (!this.currentViewRef) {
                            this.currentViewRef = this.viewContainer.createEmbeddedView(this.templateRef);
                        }
                        else {
                            this.viewContainer.insert(this.currentViewRef, this.currentViewIndex);
                        }
                        if (this.messageComponent) {
                            this.messageComponent.destroy();
                            this.messageComponent = null;
                        }
                        this.log('::Is Authorized::' + this.tag);
                    }
                    else {
                        if (this.currentViewRef) {
                            this.currentViewIndex = this.viewContainer.indexOf(this.currentViewRef);
                            this.viewContainer.detach(this.currentViewIndex);
                        }
                        if (this.error && this.error.length > 0) {
                            this.log('::Found Error message for ::' + this.tag);
                            this.renderAuthorizationMessage(this.error, 'H');
                            this.log('::Error message rendered for ::' + this.tag);
                        }
                    }
                    this.log('::Is Not Authorized::' + this.tag);
                    this.log('::: End Log :::');
                }
            });
        }
    }
    renderAuthorizationMessage(message, severity) {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(AuthorizationMessageComponent);
        if (!this.messageComponent)
            this.messageComponent = this.viewContainer.createComponent(componentFactory);
        this.messageComponent.instance.message = this.error;
        this.messageComponent.instance.severiity = severity;
    }
    log(l) {
        if (this.debug) {
            console.log(l);
        }
    }
    getProperty(tag, obj) {
        if (typeof obj !== 'object') {
            this.log('getProperty: obj is not an object');
        }
        if (typeof tag !== 'string') {
            this.log('getProperty: tag is not a string');
        }
        // Replace [] notation with dot notation
        tag = tag.replace(/\[["'`](.*)["'`]\]/g, '.$1');
        const val = tag.split('.').reduce(function (prev, curr) {
            return prev ? prev[curr] : undefined;
        }, obj);
        return val;
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    static { this.ɵfac = function DefaultAuthTagDirective_Factory(t) { return new (t || DefaultAuthTagDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(AuthorizationService), i0.ɵɵdirectiveInject(i0.ComponentFactoryResolver)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: DefaultAuthTagDirective, selectors: [["", "defaultAuthTag", ""]], inputs: { defaultAuthTag: "defaultAuthTag", defaultAuthTagDebug: "defaultAuthTagDebug", defaultAuthTagDisable: "defaultAuthTagDisable", defaultAuthTagError: "defaultAuthTagError" }, features: [i0.ɵɵNgOnChangesFeature] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DefaultAuthTagDirective, [{
        type: Directive,
        args: [{
                selector: '[defaultAuthTag]'
            }]
    }], () => [{ type: i0.TemplateRef }, { type: i0.ViewContainerRef }, { type: AuthorizationService }, { type: i0.ComponentFactoryResolver }], { defaultAuthTag: [{
            type: Input
        }], defaultAuthTagDebug: [{
            type: Input
        }], defaultAuthTagDisable: [{
            type: Input
        }], defaultAuthTagError: [{
            type: Input
        }] }); })();

class AuthorizationsModule {
    static forRoot() {
        return {
            ngModule: AuthorizationsModule
        };
    }
    static { this.ɵfac = function AuthorizationsModule_Factory(t) { return new (t || AuthorizationsModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AuthorizationsModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, FormsModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthorizationsModule, [{
        type: NgModule,
        args: [{
                declarations: [AuthorizationsComponent, AuthorizationMessageComponent, AuthTagDirective, AuthorizationViewerComponent, DefaultAuthTagDirective],
                imports: [
                    CommonModule, FormsModule
                ],
                exports: [AuthorizationsComponent, AuthorizationMessageComponent, AuthTagDirective, AuthorizationViewerComponent, DefaultAuthTagDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(AuthorizationsModule, { declarations: [AuthorizationsComponent, AuthorizationMessageComponent, AuthTagDirective, AuthorizationViewerComponent, DefaultAuthTagDirective], imports: [CommonModule, FormsModule], exports: [AuthorizationsComponent, AuthorizationMessageComponent, AuthTagDirective, AuthorizationViewerComponent, DefaultAuthTagDirective] }); })();

class AppUIAuthorizationService extends UIAuthorizationService {
    constructor(authorizationService) {
        super(authorizationService);
    }
    static { this.ɵfac = function AppUIAuthorizationService_Factory(t) { return new (t || AppUIAuthorizationService)(i0.ɵɵinject(AuthorizationService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AppUIAuthorizationService, factory: AppUIAuthorizationService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AppUIAuthorizationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [{ type: AuthorizationService }], null); })();

class ValidateTag {
    static validate(tag, obj) {
        if (typeof obj !== 'object') { //console.log('getProperty: obj is not an object'); 
        }
        if (typeof tag !== 'string') { //console.log('getProperty: tag is not a string'); 
        }
        // Replace [] notation with dot notation
        tag = tag.replace(/\[["'`](.*)["'`]\]/g, '.$1');
        const val = tag.split('.').reduce(function (prev, curr) {
            return prev ? prev[curr] : undefined;
        }, obj);
        return val ? true : false;
    }
}

/*
 * Public API Surface of authorizations-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AppUIAuthorizationService, AuthTagDirective, AuthorizationMessageComponent, AuthorizationService, AuthorizationViewerComponent, AuthorizationsComponent, AuthorizationsModule, DefaultAuthTagDirective, UIAuthorizationService, ValidateTag };
